.container {
    display: grid;
    grid-template-columns: 400px 1fr;
    height: 100%;
    margin-top: 0.75px;
    overflow: hidden;
}

.preview-and-edit-container {
    background-color: var(--white);
    padding: 16px;
    height: 100%;
    box-sizing: border-box;
    position: relative;
    overflow: auto;
}

.preview-base {
    background: linear-gradient(
            180deg,
            rgba(187, 151, 246, 0.16) 0%,
            rgba(139, 92, 246, 0.16) 50%,
            rgba(96, 43, 204, 0.16) 100%
        ),
        #fff;
    box-sizing: border-box;
}

.preview {
    composes: preview-base;
    padding: 52px 48px 0;
    height: 100%;
}

.preview-generating {
    composes: preview-base;
    padding: 52px 48px 52px;
    height: 100%;
}

@keyframes textShimmer {
    0% {
        background-position: -100% 0;
    }
    100% {
        background-position: 200% 0;
    }
}

.generating-container {
    background-color: var(--white);
    padding: 16px;
    height: 100%;
    box-sizing: border-box;
    position: relative;
    border-radius: 8px;
    border: 1px solid var(--ai-purple-border);
}

.generating-text {
    position: absolute;
    top: -32px;
    width: 100%;
    text-align: center;
    color: var(--ai-purple-primary);
    font-weight: 500;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
}

.generating-text-animated {
    background: linear-gradient(
        90deg,
        #602bcc 0%,
        #602bcc 40%,
        #b89ee5 50%,
        #602bcc 60%,
        #602bcc 100%
    );
    background-size: 200% 100%;
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    animation: textShimmer 1.5s linear infinite alternate;
}

.error-text {
    color: #666;
    font-weight: 500;
}
